import { render, staticRenderFns } from "./BigPictureWrapper.vue?vue&type=template&id=12c14a7c&scoped=true"
import script from "./BigPictureWrapper.vue?vue&type=script&lang=ts"
export * from "./BigPictureWrapper.vue?vue&type=script&lang=ts"
import style0 from "./BigPictureWrapper.vue?vue&type=style&index=0&id=12c14a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c14a7c",
  null
  
)

export default component.exports